import z from 'zod';

export const tokenResponseModel = z.object({
    token: z.string().min(1),
    refreshToken: z.string().min(1),
    refresh_token_expiration: z.number().optional(),
});

export const ssoTokenResponseModel = z.object({
    access_token: z.string().min(1),
    refresh_token: z.string().min(1),
});

export type TokenResponse = z.infer<typeof tokenResponseModel>;
export type SsoTokenResponse = z.infer<typeof ssoTokenResponseModel>;
